import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminVehicleCategories() {
  return (
    <AdminCrud
      title="Vehicle Categories"
      resource="vehicle-categories"
      defaultItem={{ name: "", slug: "", icon: "car", description: "", order: 1 }}
      fields={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug (URL)" },
        { key: "icon", label: "Icon name (car / bus / bus-front)" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}
